<template>
<div class="chapter">
<div class="inner_page">
<div class="div_autre">
<div class="pre" id="pre-001"><a id="page_12">
<h1 class="pre_tit"><span>ABBREVIATIONS</span></h1>
<div class="dev">
<div class="tableau" id="tab-001">
<div class="table-align">
<table border="0" cellpadding="2" cellspacing="0">
<colgroup>
<col width="20%"/>
<col/>
</colgroup>
<tbody>
<tr valign="top">
<td valign="top"><p class="txt_courant"><i>BBR</i></p></td>
<td valign="top"><p class="txt_courant"><i>Bulletin for Biblical Research</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant"><i>CBQ</i></p></td>
<td valign="top"><p class="txt_courant"><i>Catholic Biblical Quarterly</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant"><i>CJ</i></p></td>
<td valign="top"><p class="txt_courant"><i>Concordia Journal</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant"><i>CSR</i></p></td>
<td valign="top"><p class="txt_courant"><i>Christian Scholars Review</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant"><i>EQ</i></p></td>
<td valign="top"><p class="txt_courant"><i>Evangelical Quarterly</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant"><i>ERT</i></p></td>
<td valign="top"><p class="txt_courant"><i>Evangelical Review of Theology</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant"><span class="small">ESV</span></p></td>
<td valign="top"><p class="txt_courant">English Standard Version</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant"><i>JETS</i></p></td>
<td valign="top"><p class="txt_courant"><i>Journal of the Evangelical Theological Society</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant"><i>JSNT</i></p></td>
<td valign="top"><p class="txt_courant"><i>Journal for the Study of the New Testament</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant"><span class="small">KJV</span></p></td>
<td valign="top"><p class="txt_courant">King James Version</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant"><i>NDBT</i></p></td>
<td valign="top"><p class="txt_courant"><i>New Dictionary of Biblical Theology</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant"><span class="small">NEB</span></p></td>
<td valign="top"><p class="txt_courant">New English Bible</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant"><span class="small">NIV</span></p></td>
<td valign="top"><p class="txt_courant">New International Version</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant"><span class="small">NKJV</span></p></td>
<td valign="top"><p class="txt_courant">New King James Version</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant"><span class="small">NRSV</span></p></td>
<td valign="top"><p class="txt_courant">New Revised Standard Version</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant"><i>RTR</i></p></td>
<td valign="top"><p class="txt_courant"><i>Reformed Theological Review</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant"><i>SBET</i></p></td>
<td valign="top"><p class="txt_courant"><i>Scottish Bulletin of Evangelical Theology</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant">SHS</p></td>
<td valign="top"><p class="txt_courant">Scripture and Hermeneutics Series</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant"><i>SJT</i></p></td>
<td valign="top"><p class="txt_courant"><i>Scottish Journal of Theology</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant"><i>TB</i></p></td>
<td valign="top"><p class="txt_courant"><i>Tyndale Bulletin</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant"><i>TJ</i></p></td>
<td valign="top"><p class="txt_courant"><i>Trinity Journal</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant"><i>TT</i></p></td>
<td valign="top"><p class="txt_courant"><i>Theology Today</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant"><i>WTJ</i></p></td>
<td valign="top"><p class="txt_courant"><i>Westminster Theological Journal</i></p></td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</a></div><a id="page_12">
</a></div><a id="page_12">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pre2.vue?760bf101